import { useState, useEffect } from "react";
import "./ContactSection.css";
import ContactWizard from "./ContactWizard";
import QuickLead from "@/components/QuickLead/QuickLead";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useLocale } from "@/i18n/useLocale";

function ContactSection() {
  const { t } = useLocale();
  const [showSuccess, setShowSuccess] = useState(false);
  const titleRef = useScrollReveal<HTMLDivElement>();
  // El wizard entra apenas despues del titulo: primero se lee la invitacion,
  // despues aparece el formulario.
  const wizardRef = useScrollReveal<HTMLDivElement>({ delay: 140 });

  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => setShowSuccess(false), 8000);
      return () => clearTimeout(timer);
    }
  }, [showSuccess]);

  const handleSuccess = () => {
    setShowSuccess(true);
  };

  return (
    <section className="contact-section" id="contacto">
      <div className="contact-section__content">
        <div className="contact-section__text reveal--from-left" ref={titleRef}>
          <h2 className="contact-section__title">{t.contact.title}</h2>

          <p className="contact-section__description">
            {t.contact.description}
          </p>
        </div>

        <div className="contact-section__right" ref={wizardRef}>
          {showSuccess ? (
            <div className="wizard-success">
              <div className="wizard-success__icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h2 className="wizard-success__title">{t.contact.successTitle}</h2>
              <p className="wizard-success__msg">{t.contact.successMsg}</p>
              <button
                className="wizard-btn wizard-btn--primary"
                onClick={() => setShowSuccess(false)}
              >
                {t.contact.successCta}
              </button>
            </div>
          ) : (
            <ContactWizard onSuccess={handleSuccess} />
          )}
        </div>

        {/* Atajo para quien no va a completar cinco pasos hoy. Convive con el
            wizard en vez de reemplazarlo: el que quiere calificarse igual usa
            el formulario largo. Es un area de grid aparte (no un hijo de
            .contact-section__text) para poder ubicarla debajo del wizard en
            mobile sin que dependa del texto de arriba. */}
        <div className="contact-section__quick">
          <QuickLead />
        </div>
      </div>
    </section>
  );
}

export default ContactSection;